import { SVG } from './SVG';
const IconInstagramAlt1 = () => {
  return (
    <SVG width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 7.16992H17.51M7 2.66992H17C19.7614 2.66992 22 4.9085 22 7.66992V17.6699C22 20.4313 19.7614 22.6699 17 22.6699H7C4.23858 22.6699 2 20.4313 2 17.6699V7.66992C2 4.9085 4.23858 2.66992 7 2.66992ZM16 12.0399C16.1234 12.8722 15.9813 13.7221 15.5938 14.4689C15.2063 15.2157 14.5931 15.8213 13.8416 16.1996C13.0901 16.5779 12.2384 16.7095 11.4078 16.5759C10.5771 16.4422 9.80976 16.05 9.21484 15.4551C8.61992 14.8602 8.22773 14.0928 8.09407 13.2621C7.9604 12.4315 8.09207 11.5798 8.47033 10.8283C8.84859 10.0768 9.45419 9.46366 10.201 9.07616C10.9478 8.68866 11.7978 8.54651 12.63 8.66992C13.4789 8.79581 14.2649 9.19139 14.8717 9.79823C15.4785 10.4051 15.8741 11.191 16 12.0399Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export { IconInstagramAlt1 as default, IconInstagramAlt1 };
